<template>
  <div>
    <b-row>
      <b-col md="8" style="text-align: right;">{{selected_item_text || "Select Dropdown"}} Interest</b-col>
      <b-col md="4" style="text-align: left;">
        <b-button-group v-b-hover="handleHover" vertical>
          <b-button size="sm" v-if="showUndo"
            :variant="isHovered ? 'warning' : 'primary'"
            class="mb-2"
            v-b-tooltip.hover.right title="Change selection"
            @click="unsetSelection"
            >
            <b-icon-arrow-clockwise aria-label="Undo"></b-icon-arrow-clockwise>
          </b-button>
        </b-button-group>
      </b-col>
    </b-row>
    <div v-if="showTable">
      <interest-select
        :filtering="filtering"
        :select_table_heading="heading"
        @selectedItems="setInterest"
      >
      </interest-select>
    </div>
  </div>
</template>

<script>
import InterestSelect from './InterestSelect.vue'
import {
  BIconArrowClockwise
} from 'bootstrap-vue'

export default {
  components: {
    InterestSelect,
    BIconArrowClockwise
  },
  props: {
    heading: {
      Type: String
    },
    filtering: {
      Type: Object
    }
  },
  data () {
    return {
      isHovered: false,
      interest_id: undefined,
      selected_item_text: undefined,
      no_heading: ""
    }
  },
  computed: {
    showUndo() {
      return this.interest_id !== undefined
    },
    showTable() {
      return this.interest_id === undefined
    }
  },
  methods: {
    handleHover(hovered) {
      this.isHovered = hovered
    },
    setInterest(items) {
      this.interest_id = items[0].id
      this.selected_item_text = items[0].attributes['name']
      this.$emit('selectedItems', items)
    },
    unsetSelection() {
      this.interest_id = undefined
      this.selected_item_text = undefined
    }
  }
}
</script>
